import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { toggleAward, award, fetchICA } from 'entries/ducks';
import AwardModal from 'entries/components/award_modal';

const mapStateToProps = (state) => {
  const { awardingEntry, awardingEntryAward, ica } = state.entries;

  return {
    showing: !!awardingEntry,
    contract: { pdf: ica },
    signingAs: 'client',
    header: 'award entry',
    collapsable: true,
    uncollapseLabel: "Award and sign contract",
    title: awardingEntry? `Award ${awardingEntry.author_username}?` : '',
    uncollapsedTitle: 'Sign the project contract',
    entry: awardingEntry,
    entryAward: awardingEntryAward
  };
};

export default connect(mapStateToProps, {
  onClose: partial(toggleAward, null, null),
  customSignRequest: award,
  fetchICA
})(AwardModal);



// WEBPACK FOOTER //
// ./entries/containers/award_modal.js